import { useMemo } from "react";
import { CONCIERGE_PRODUCT_FORM_CONTAINER_ID } from "../../../concierge/initializer";
import { log } from "../../../monitoring/log";
import { getPdpAddProductForm } from "../../../product-page";
import { isOnProductPage } from "../../../shopify";
import { RedoBackInStockContainerElement } from "./element";

export const TAPCART_SELECTOR = "#redo_tapcart_container";

export function useBackInStockRoot(): RedoBackInStockContainerElement | null {
  const backInStockElement = useMemo(() => {
    // Check if we're on a product page or have the concierge container
    const onTapcart = !!globalThis.Tapcart && !globalThis.Shopify;
    const hasConciergeContainer = !!document.querySelector(
      CONCIERGE_PRODUCT_FORM_CONTAINER_ID,
    );

    if (!isOnProductPage(onTapcart) && !hasConciergeContainer) {
      return null;
    }

    const form = getPdpAddProductForm({ onTapcart });

    if (!form) {
      log("back-in-stock: no form found");
      return null;
    }

    log("back-in-stock embedding form", form);

    // Register the custom element if not already registered
    RedoBackInStockContainerElement.register();

    const backInStockElement = document.createElement(
      RedoBackInStockContainerElement.TAG,
    ) as RedoBackInStockContainerElement;
    backInStockElement.id = "redo-back-in-stock-container";

    form.append(backInStockElement);

    return backInStockElement;
  }, []);

  return backInStockElement;
}
